export default __webpack_public_path__ + "static/media/761.c9c0290e.png";